export const sendEmailStyle = {
	radioGroup: {
		marginTop: '40px',
	},
	radioItem: {
		minWidth: '570px',
		borderRadius: '8px',
		border: '1px solid var(--neutral-100)',
		padding: '16px',
		marginBottom: '16px',
	},
	selectedRadioItem: {
		border: '1px solid var(--primary-500)',
	},

	description: {
		color: 'var(--neutral-300)',
	},
};
